<template>
  <div class="news">
    <div class="section">
      <div class="bread">
        <BreadCreamVue :data="BreadCreamData" />
      </div>
      <ul class="flex-col no-padding">
        <li v-for="item in data" :key="item.id">
          <NewsBlockVue :data="item"></NewsBlockVue>
        </li>
      </ul>
      <PaginationVue
        :curPage="query.page"
        :count="count"
        @on-page-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, watch } from "@vue/composition-api";
import BreadCreamVue from "@/components/BreadCream.vue";
import NewsBlockVue from "./NewsBlock.vue";
import PaginationVue from "@/components/Pagination.vue";
import { useFetchList } from "@/hooks/fetch-list";
import { api } from "../../utils/apis";
export default defineComponent({
  name: "News",
  components: {
    BreadCreamVue,
    NewsBlockVue,
    PaginationVue,
  },
  setup(props, ctx) {
    const BreadCreamData = [
      {
        title: "NEWS",
        to: "/news",
      },
      {
        title: "LIST",
        to: "",
      },
    ];

    const { data, count, handlePageChange, query, isLoading } = useFetchList({
      api: api.news.list,
      ctx,
    });

    watch(
      () => data.value,
      () => {
        // 跳转地址是news/${id}
        data.value && data.value.forEach((it) => (it.to = "/news"));
      }
    );

    return { query, data, count, BreadCreamData, handlePageChange, isLoading };
  },
});
</script>
<style lang="scss" scoped>
.news {
  background: #fcfcfc;
  padding-bottom: 40px;
}
</style>
